import React from "react";
import { Input } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";
import "./index.scss";

/**
 * @desc Input for convention form.
 */
export const InputConvention = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-cname-error",
  };

  const inputProps = {
    type: "text",
    id: "input-cname",
    className: "form-control",
    "aria-describedby": errorProps.id,
    placeholder: "Convention ID",
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "CONVENTION ID",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.CID,
  };

  return (
    <div className="input-convention">
      <Input {...parentProps} />
    </div>
  );
};
